/*
 * https://www.algolia.com/doc/api-reference/widgets/clear-refinements/js/
 */
import { clearRefinements } from 'instantsearch.js/es/widgets'
import { containers } from "./selectors"

export const productsClearRefinements = clearRefinements({
    container: containers.clearRefinements,
    cssClasses: {
        button: [
            'inline-block ml-4 font-sans text-xs font-bold text-blue-500 underline uppercase',
        ],
    },
    templates: {
        resetLabel: 'Clear All Filters',
    },
})
